// ============================================================================
// Entity: Permissions
// Key: permissions
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getPermissionsListQueryKey,
	getPermissionsListQueryOptions,
	getPermissionsRelationsRolesAssignedQueryKey,
	getPermissionsRelationsRolesAssignedQueryOptions,
	getPermissionsRelationsRolesAvailableQueryKey,
	getPermissionsRelationsRolesAvailableQueryOptions,
	getRolesListQueryKey,
	permissionsRelationsRolesAssign,
	permissionsRelationsRolesUnassign,
} from '../api/backstage'
// #region Imports
import type {
	PagedResultOfPermissionSummary,
	PagedResultOfRolePermissionDto,
	PagedResultOfRoleSummary,
	RolePermissionDto,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const permissionsEntityEndpoints = {
	list: defineQueryEndpoint<
		PagedResultOfPermissionSummary,
		undefined,
		ListQueryParams
	>({
		key: 'permissions.list',
		method: 'GET',
		path: '/admin/permissions',
		queryKey: (args) => getPermissionsListQueryKey(args?.queryParams),
		queryOptions: (args) => getPermissionsListQueryOptions(args?.queryParams),
	}),
} as const
// #endregion

// #region Relations
// #region Relation: Roles
// Target Entity: roles
const permissionsRolesRelation = {
	key: 'roles',
	targetEntity: 'roles',
	endpoints: {
		assign: defineMutationEndpoint<
			RolePermissionDto[],
			(number | string)[],
			{ permissionId: number }
		>({
			key: 'permissions.relations.roles.assign',
			method: 'POST',
			path: '/admin/permissions/{permissionId}/roles',
			pathParams: ['permissionId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					permissionId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					permissionsRelationsRolesAssign(
						variables.permissionId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getPermissionsRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getPermissionsRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getPermissionsListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
		assigned: defineQueryEndpoint<
			PagedResultOfRolePermissionDto,
			{ permissionId: number },
			ListQueryParams
		>({
			key: 'permissions.relations.roles.assigned',
			method: 'GET',
			path: '/admin/permissions/{permissionId}/roles',
			pathParams: ['permissionId'] as const,
			queryKey: (args) =>
				getPermissionsRelationsRolesAssignedQueryKey(
					args?.pathParams?.permissionId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getPermissionsRelationsRolesAssignedQueryOptions(
					args?.pathParams?.permissionId,
					args?.queryParams,
				),
		}),
		available: defineQueryEndpoint<
			PagedResultOfRoleSummary,
			{ permissionId: number },
			ListQueryParams
		>({
			key: 'permissions.relations.roles.available',
			method: 'GET',
			path: '/admin/permissions/{permissionId}/assignable-roles',
			pathParams: ['permissionId'] as const,
			queryKey: (args) =>
				getPermissionsRelationsRolesAvailableQueryKey(
					args?.pathParams?.permissionId,
					args?.queryParams,
				),
			queryOptions: (args) =>
				getPermissionsRelationsRolesAvailableQueryOptions(
					args?.pathParams?.permissionId,
					args?.queryParams,
				),
		}),
		unassign: defineMutationEndpoint<
			void,
			(number | string)[],
			{ permissionId: number }
		>({
			key: 'permissions.relations.roles.unassign',
			method: 'DELETE',
			path: '/admin/permissions/{permissionId}/roles',
			pathParams: ['permissionId'] as const,
			mutationOptions: () => ({
				mutationFn: (variables: {
					permissionId: number | string | null | undefined
					data: (number | string)[]
				}) =>
					permissionsRelationsRolesUnassign(
						variables.permissionId,
						variables.data,
					),
			}),
			invalidates: [
				(context) =>
					getPermissionsRelationsRolesAssignedQueryKey(
						context.ownerId ?? context.entityId,
					),
				(context) =>
					getPermissionsRelationsRolesAvailableQueryKey(
						context.ownerId ?? context.entityId,
					),
				(_context) => getPermissionsListQueryKey(),
				(_context) => getRolesListQueryKey(),
			],
		}),
	},
} as const
// #endregion
// #endregion

// #region Entity Config Export
export const permissionsEntityConfig = {
	key: 'permissions',
	kind: 'entity',
	entity: {
		idField: 'id',
		idParam: 'permissionId',
		routePath: '/permissions',
	},
	endpoints: permissionsEntityEndpoints,
	relations: {
		roles: permissionsRolesRelation,
	},
} as const satisfies EntityConfig<'permissions'>
// #endregion
